module.exports = __webpack_public_path__ + "static/media/Angel Huntington-Ortega.ef312ef6.png";